import React, { FC, ReactNode } from 'react';
import './SplitContainer.scss';

export const SplitContainer: FC<{
  left: ReactNode;
  right: ReactNode;
}> = ({ left, right }) => {
  return (
    <div className="splitContainer">
      <div className="split">
        <div className="splitLeft">{left}</div>
        {right}
      </div>
    </div>
  );
};
